import { render } from "./TombamentoPlanilhaView.vue?vue&type=template&id=b1e79328&scoped=true"
import script from "./TombamentoPlanilhaView.vue?vue&type=script&lang=js"
export * from "./TombamentoPlanilhaView.vue?vue&type=script&lang=js"

import "./TombamentoPlanilhaView.vue?vue&type=style&index=0&id=b1e79328&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e79328"]])

export default __exports__